import React from "react";
import { useTranslation } from "react-i18next";

import SectionBadge from "@/components/shared/Title";
import PhoneFeatureGroup from "./PhoneFeatureGroup";
import AppStoreButtons from "./AppStoreButtons";

import { mobileAppData } from "@/features/mobile-app/data/mobileAppData";
import { GrServices } from "react-icons/gr";

import MotionDiv from "@/components/animations/MotionDiv";
import { fadeUp, stagger, scaleUp } from "@/animations/variants";

import { useScreens } from "@/hooks/useScreens";

const MobileAppSection = () => {
  const { t, i18n } = useTranslation();
  const isAR = i18n.language?.startsWith("ar");

  const { screens, loading, error } = useScreens("mob", isAR);

  const displayData = mobileAppData.map((staticItem, index) => {
    const backendItem = screens[index];

    return {
      ...staticItem,
      image: backendItem?.image || staticItem.image,
      title: backendItem?.title || null,
      icon: backendItem?.icon || null,
    };
  });

  return (
    <section id="services" className="overflow-hidden py-10">
      <div className="container mx-auto px-4">
        <MotionDiv variants={fadeUp}>
          <SectionBadge text={t("mobileApp.badge")} icon={<GrServices />} />
        </MotionDiv>

        <MotionDiv variants={fadeUp}>
          <h2 className="mx-auto mt-6 max-w-4xl text-center text-4xl font-semibold text-gray-800">
            {t("mobileApp.title")}
          </h2>
        </MotionDiv>

        {loading && (
          <p className="mt-10 text-center text-sm text-gray-500">
            {isAR ? "جاري تحميل شاشات التطبيق..." : "Loading mobile screens..."}
          </p>
        )}

        {!loading && error && (
          <p className="mt-10 text-center text-sm text-red-500">{error}</p>
        )}

        {!loading && !error && (
          <MotionDiv
            variants={stagger}
            className="mt-10 flex flex-col items-center justify-center gap-14 md:flex-row md:items-end"
          >
            {displayData.map((item, i) => (
              <MotionDiv key={i} variants={scaleUp}>
                <PhoneFeatureGroup
                  image={item.image}
                  size={item.size}
                  moveBottomFeatureTopOnMobile={i === 1}
                  topFeature={
                    item.topFeature && {
                      ...item.topFeature,
                      icon: item.icon || item.topFeature.icon,
                      text: item.title || t(item.topFeature.text),
                    }
                  }
                  bottomFeature={
                    item.bottomFeature && {
                      ...item.bottomFeature,
                      icon: item.icon || item.bottomFeature.icon,
                      text: item.title || t(item.bottomFeature.text),
                    }
                  }
                />
              </MotionDiv>
            ))}
          </MotionDiv>
        )}
      </div>

      <MotionDiv variants={fadeUp} className="mt-2 flex justify-center">
        <AppStoreButtons />
      </MotionDiv>
    </section>
  );
};

export default MobileAppSection;
